// extracted by mini-css-extract-plugin
export default {"futureQuantityWrapper":"futureQuantityWrapper__DfkB7","totalToBeScheduled":"totalToBeScheduled__ISfHd","label":"label__PQdWI","value":"value__18-h0","row":"row__3omW6"};